import {initMainHeader} from '../js/src/header-init';
import {replaceGMapLink} from "../js/src/utils";
import '../scss/pages/events.scss';

initMainHeader();
replaceGMapLink();
